import React from 'react';
import { useSelector } from 'react-redux';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { preOverquotaBanner, preQuotaOfferLimit } from 'reactApp/appHelpers/featuresHelpers/features/overquotaPre';
import { isAlertForOverquota } from 'reactApp/modules/features/features.helpers';
import { getUserOverquotaCycleCount } from 'reactApp/modules/profile/profile.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { OverquotaBanner } from 'reactApp/ui/OverquotaBanner/OverquotaBanner';
import { PreOverquotaBanner } from 'reactApp/ui/PreOverquotaBanner/PreOverquotaBanner';

export const useOverquotaBanner = ({ isAllDocuments }) => {
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isOverquota = useSelector(UserQuotaSelectors.isOverquota);
    const cycleCount = useSelector(getUserOverquotaCycleCount);
    const { used: usedPercent } = useSelector(UserQuotaSelectors.getFilledPercents);

    const showOverquotaBanner = Boolean(isOverquota && isAlertForOverquota && !isBizUser && !IS_ONPREMISE && !isAllDocuments);

    const showPreOverquotaBanner =
        !showOverquotaBanner &&
        preOverquotaBanner &&
        !isPaidUser &&
        usedPercent >= preQuotaOfferLimit &&
        cycleCount >= 1 &&
        !isBizUser &&
        !IS_ONPREMISE &&
        !isAllDocuments;

    if (showOverquotaBanner) {
        return <OverquotaBanner />;
    }

    if (showPreOverquotaBanner) {
        return <PreOverquotaBanner />;
    }

    return null;
};
